import Search from "antd/es/input/Search";

import FlexContainer from "@/components/FlexContainer";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { setWorkPlanQuery } from "@/store/slices/ui";

import { MarketSort } from "../MarketSort";

export const SearchAndSortControls = () => {
    const dispatch = useAppDispatch();
    const { query } = useAppSelector((state) => state.ui.workPlan);

    return (
        <FlexContainer gap="8px" margin="16px 0" alignItems="center">
            <Search
                placeholder="Введіть назву чи адресу"
                value={query}
                size="large"
                onChange={(e) => dispatch(setWorkPlanQuery(e.target.value))}
                allowClear
            />
            <MarketSort />
        </FlexContainer>
    );
};
